import script from "./MessengerIconBase.vue?vue&type=script&setup=true&lang=js"
export * from "./MessengerIconBase.vue?vue&type=script&setup=true&lang=js"

import "./MessengerIconBase.vue?vue&type=style&index=0&id=3d923896&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d923896"]])

export default __exports__